// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const IMPORT_SCRATCH_FILE_STEP_SHAPES = [
  {
    stepType: PipelineStepType.IMPORT_SCRATCH_FILE,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Output file': {
        systemName: 'Output file',
        displayName: 'Output file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      scratchFileId: {
        kind: 'domain',
        required: true,
        types: [
          'SCRATCH_FILE'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
